
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/2020-introducing-sketch",
      function () {
        return require("private-next-pages/blog/2020-introducing-sketch.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/2020-introducing-sketch"])
      });
    }
  